import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useKnowledgeDocument, useUpdateDocument } from '@/hooks/useKnowledge';
import { DocumentEditForm } from '@/components/knowledge/DocumentEditForm';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

export function KnowledgeEditPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    if (location.key !== 'default') {
      navigate(-1);
    } else {
      navigate(`/knowledge/${id}`);
    }
  };

  const { data: document, isLoading } = useKnowledgeDocument(id!);
  const updateMutation = useUpdateDocument(id!);

  if (isLoading) {
    return (
      <div className="container mx-auto py-8">
        <div className="text-center py-12 text-muted-foreground">
          Carregando documento...
        </div>
      </div>
    );
  }

  if (!document) {
    return (
      <div className="container mx-auto py-8">
        <div className="text-center py-12 text-muted-foreground">
          Documento não encontrado
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto py-8 space-y-6">
      <div className="flex items-center gap-4">
        <Button variant="ghost" onClick={handleBack}>
          <ArrowLeft className="h-4 w-4 mr-2" />
          Voltar
        </Button>
        <h1 className="text-3xl font-bold">Editar Documento</h1>
      </div>

      <DocumentEditForm
        document={document}
        onSubmit={(data) => {
          updateMutation.mutate(data, {
            onSuccess: () => navigate(`/knowledge/${id}`),
          });
        }}
        isLoading={updateMutation.isPending}
      />
    </div>
  );
}
